import { useForm } from "react-hook-form";
import { useCarriersContext } from "../../use-carriers-context";
import { z } from "zod";
import { v4 as uuidv4 } from "uuid";
import { zodResolver } from "@hookform/resolvers/zod";

const formSchema = z.object({
  id: z.string().trim().min(1, { message: "Required" }),
  key: z.string().trim().min(1, { message: "Required" }),
  value: z.string().trim().min(1, { message: "Required" }),
  operator: z.string().trim().min(1, { message: "Required" }),
  positiveResult: z.string().trim().min(1, { message: "Required" }),
});

type CreateOneRoutingLocationRuleValues = z.infer<typeof formSchema>;

type CreateOneRoutingLocationRuleProps = {
  onSubmit: (values: CreateOneRoutingLocationRuleValues) => void;
};

export const useAddRoutingLocationRulesForm = ({
  onSubmit,
}: CreateOneRoutingLocationRuleProps) => {
  const { shop } = useCarriersContext();

  const defaultLocation =
    shop.locations.find((s) => s.isDefault) || shop.locations[0];

  const form = useForm<CreateOneRoutingLocationRuleValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      id: uuidv4(),
      key: "reasonId",
      value: shop.reasons[0].id || "",
      operator: "equals",
      positiveResult: defaultLocation.id || "",
    },
  });

  const handleSubmit = form.handleSubmit(
    (data: CreateOneRoutingLocationRuleValues) => {
      onSubmit(data);
    },
  );

  return {
    form,
    setValue: form.setValue,
    control: form.control,
    handleSubmit,
    values: form.watch(),
  };
};
